import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

/**
 * Apple Mail with the invite open. Not a NordVPN surface — the point is that
 * the invite arrives somewhere the member already trusts, before any Nord
 * software is involved.
 */
export function MailApp({ v }: { v: Vals }) {
  return (
    <div style={sx('position:absolute;inset:0;padding-top:56px;display:flex;flex-direction:column;background:#1c1c1e')}>
      <div
        style={sx(
          'padding:8px 16px 12px;display:flex;align-items:center;gap:8px;' +
            'border-bottom:1px solid rgba(255,255,255,.08)'
        )}
      >
        <Hov
          as="button"
          onClick={v.kBackToLock}
          style={sx(
            'display:flex;align-items:center;gap:4px;padding:0;border:none;background:transparent;' +
              'cursor:pointer;font-family:inherit;font-size:var(--fs-sm);color:#0a84ff'
          )}
          hoverStyle={sx('opacity:.7')}
        >
          <span
            style={sx(
              'width:14px;height:14px;background:#0a84ff;' +
                '-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;' +
                'mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat'
            )}
          />
          Inbox
        </Hov>
      </div>

      <div style={sx('flex:1;min-height:0;overflow:auto;padding:18px 20px 24px;display:flex;flex-direction:column;gap:16px')}>
        <span style={sx('font-size:var(--fs-xl);font-weight:var(--fw-bold);line-height:26px;color:#fff')}>
          You have been invited to a NordVPN group
        </span>

        <div style={sx('display:flex;align-items:center;gap:10px')}>
          <span
            style={sx(
              'width:36px;height:36px;flex:none;border-radius:var(--radius-full);background:var(--bg-accent);' +
                'display:flex;align-items:center;justify-content:center'
            )}
          >
            <span
              style={sx(
                'width:18px;height:18px;background:#fff;' +
                  '-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;' +
                  'mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat'
              )}
            />
          </span>
          <span style={sx('flex:1;display:flex;flex-direction:column;gap:1px;min-width:0')}>
            <span style={sx('font-size:var(--fs-sm);font-weight:var(--fw-medium);color:#fff')}>
              NordVPN
            </span>
            <span style={sx('font-size:var(--fs-2xs);color:rgba(255,255,255,.5)')}>
              to {v.memberEmailAddress}
            </span>
          </span>
          <span style={sx('font-size:var(--fs-2xs);color:rgba(255,255,255,.5);flex:none')}>now</span>
        </div>

        <span style={sx('font-size:var(--fs-sm);line-height:22px;color:rgba(255,255,255,.8)')}>
          {v.managerEmailAddress} has paid for a seat on their NordVPN group plan and would like you
          to have it.
        </span>
        <span style={sx('font-size:var(--fs-sm);line-height:22px;color:rgba(255,255,255,.8)')}>
          You will get your own Nord Account with your own login. Nothing about your activity is
          shared with them.
        </span>

        <Hov
          as="button"
          onClick={v.kOpenSignup}
          style={sx(
            'margin-top:4px;height:48px;border-radius:var(--radius-full);border:none;' +
              'background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-sm);' +
              'font-weight:var(--fw-medium);cursor:pointer'
          )}
          hoverStyle={sx('background:var(--bg-accent-active)')}
        >
          Accept invite
        </Hov>

        <span
          style={sx(
            'font-size:var(--fs-2xs);font-family:ui-monospace,Menlo,monospace;' +
              'color:rgba(255,255,255,.4);word-break:break-all'
          )}
        >
          nordaccount.com/join/8FQ2-14KD
        </span>
      </div>
    </div>
  )
}
